import { createFileRoute } from "@tanstack/react-router";
import ComparisonDetailPage from "@/pages/comparisons/ComparisonDetailPage";

export const Route = createFileRoute("/comparaisons/$slug")({
  component: ComparisonDetailPage,
});
